import {Component, Input, OnInit} from '@angular/core';
import {dateFromStringServerFormat, dateToString} from "../../../../shared";
import {Mensaje, Persona} from "../../../index";

@Component({
  selector: 'app-mensaje-detail',
  templateUrl: './mensaje-detail.component.html',
  styleUrls: ['./mensaje-detail.component.scss']
})
export class MensajeDetailComponent implements OnInit {
  @Input() mensaje: Mensaje = null;
  @Input() persona: Persona = null;

  nombre: string = null;
  fecha: string = null;

  constructor() {
  }

  ngOnInit(): void {
    this.nombre = this.persona.name();
    this.fecha = dateToString(
      dateFromStringServerFormat(this.mensaje.mensajeFecha)
    );
  }
}
